import Breakpoints from '~/constants/Breakpoints';

export default {
  onlySmallAndXSmall: `(max-width: ${Breakpoints.md.min}px)`,
  onlyMediumSmallAndXSmall: `(max-width: ${Breakpoints.lg.min}px)`,
  onlyMedium: `(min-width: ${Breakpoints.md.min}px) and (max-width: ${Breakpoints.lg.min}px)`,
  onlyLarge: `(min-width: ${Breakpoints.lg.min}px) and (max-width: ${Breakpoints.xl.min}px)`,
  mediumAndBelow: `(max-width: ${Breakpoints.md.max}px)`,
  mediumAndAbove: `(min-width: ${Breakpoints.md.min}px)`,
  largeAndAbove: `(min-width: ${Breakpoints.lg.min}px)`,
  xxLargeAndAbove: `(min-width: ${Breakpoints.xxl.min}px)`
};

export function breakpoint(size) {
  // TODO: Remove this once we have a polyfill for matchMedia in place for Jjesest
  if (window.matchMedia === undefined) return false;
  return window.matchMedia(size).matches;
}
